import { env } from "@/shared/config/env";

/** Websocket URL for the signed-in user's in-app feed. */
export function notificationSocketUrl(token: string): string {
  const base = env.apiBaseUrl || window.location.origin;
  const url = new URL(base, window.location.origin);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  url.pathname = "/ws/notifications/";
  url.search = `token=${encodeURIComponent(token)}`;
  url.hash = "";
  return url.toString();
}
